<ng-scrollbar visibility="hover" #scrollable track="all" pointerEventsMethod="scrollbar">
    <main role="main" class="container">

        <div *ngIf="loader===false" id="modal-content-wrapper">

            <section id="modal-body">

                <form name="form" [formGroup]="form">

                    <div class="row" style="overflow-y: hidden">
                        <div class="clearfix"></div>
                        <div style="max-height: 35px;" class="col-md-2 text-right">
                            <app-button-drop-down
                                [mode]="mode"
                                [buttons]="buttons"
                                [taskType]="eventType"
                                (outputToParent)="getFromChildType($event)"
                                *ngIf="!module">
                            </app-button-drop-down>
                        </div>
                        <div style="max-height: 35px;" class="col-md-8 text-uppercase">
                            <h2 *ngIf="!module">{{selectedTaskTypeLabel}}</h2>
                            <h3 *ngIf="module === 'holidays'">{{selectedTaskTypeLabel}}</h3>
                        </div>
                        <div class="col-md-2 text-right">
                            <span class="badge bg-light task-number-badge"
                                  title="Broj zadatka">{{generatedTaskNumber}}</span>
                        </div>

                        <div class="clearfix"></div>
                        <div class="col-md-12 no-padding">
                            <div class="col-md-12 no-padding">
                                <div class="col-md-2 text-right">
                                    <h3 style="color: gray;font-size: 13px;">Naslov:</h3>
                                </div>
                                <div class=" col-md-10 pull-left no-padding-right ">
                                    <div class="new-task-title pb-0 form-control no-border no-padding-left" *ngIf="module === 'holidays'">
                                        Zahtjev za slobodan dan/godišnji odmor
                                    </div>
                                    <textarea rows="1"
                                              matInput
                                              class="new-task-title pb-0 form-control no-border no-padding-left"
                                              id="taskTitle"
                                              formControlName="title"
                                              (paste)="onTitlePaste($event)"
                                              spellcheck="false"
                                              placeholder="Unesite naslov zadatka *"
                                              *ngIf="!module"
                                    >
                                    </textarea>
                                    <div style="width: 120px;margin-top: 0.25rem;font-size: 80%;color: #dc3545" *ngIf="form.get('title').invalid && formSubmitted==true">
                                      Ovo polje je obavezno.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                        <div class="col-md-12 no-padding" *ngIf="eventType !== 'note' && eventType !== 'reminder' && !module">
                            <div class="col-md-12 no-padding">
                                <div class="col-md-2 text-right">
                                    <h3 style="margin-top: 16px;color: gray;font-size: 13px;">Kome:</h3>
                                </div>
                                <div class="form-group col-md-10 no-margin">
                                    <app-choose-assigned-users
                                      [ids]="assigned.value"
                                      [myForm]="form"
                                      (outputToParent)="getAssignedIds($event)">
                                    </app-choose-assigned-users>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 no-padding" *ngIf="eventType == 'task'">
                            <div class="col-md-12 no-padding">
                                <div class="col-md-2 text-right">
                                    <h3 style="margin-top: 16px;color: gray;font-size: 13px;" *ngIf="!module">Validator:</h3>
                                    <h3 style="margin-top: 16px;color: gray;font-size: 13px;" *ngIf="module === 'holidays'">Menadžer: <span class="required">*</span></h3>
                                </div>
                                <div class="form-group col-md-10 no-margin">
                                    <app-choose-validators
                                            [ids]="validator.value"
                                            [myForm]="form"
                                            (outputToParent)="getValidatorIds($event)"
                                    ></app-choose-validators>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 no-padding" *ngIf="module === 'holidays'">
                            <div class="col-md-12 no-padding">
                                <div class="col-md-2 text-right">
                                    <h3 style="margin-top: 16px;color: gray;font-size: 13px;">Zaposlenog mijenja tokom odsustva:</h3>
                                </div>
                                <div class="form-group col-md-10 no-margin">
                                    <app-choose-validators
                                            [ids]="replacement_colleague.value"
                                            [myForm]="form"
                                            (outputToParent)="getReplacementIds($event)"
                                    ></app-choose-validators>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 no-padding" *ngIf="eventType === 'task'">
                            <div class="col-md-2 p-0 text-right">
                                <h3 class="mb-0 " style="color: gray;font-size: 13px;margin-top: 25px" *ngIf="!module">Rok za
                                    izvršenje:</h3>
                                <h3 class="mb-0 " style="color: gray;font-size: 13px;margin-top: 25px" *ngIf="module === 'holidays'">Period odsustva:</h3>
                            </div>
                            <div class="col-md-2" *ngIf="!module">
                                <input class="form-control no-border form-control-sm form-control-group"
                                       placeholder="Izaberite datum"
                                       style="margin-top: 25px"
                                       (click)="d.toggle()"
                                       formControlName="deadlineDate"
                                       dateFormat="dd-MMM-yyyy"
                                       ngbDatepicker
                                       #d="ngbDatepicker">
                                <div style="width: 120px;margin-top: 0.25rem;margin-left:9px;font-size: 80%;color: #dc3545"
                                     *ngIf="(form.get('deadlineDate').invalid || form.get('deadlineTime').invalid) && formSubmitted">
                                    Ovo polje je obavezno.
                                </div>
                            </div>
                            <div class="col-md-2" *ngIf="module === 'holidays'">
                                <input #creationDateRangeInput class="form-control d-inline-block period"
                                        placeholder="Izaberite datum" name="dp"  ngbDatepicker
                                        readonly [dayTemplate]="creation"
                                        [autoClose]="false" [displayMonths]="2" [maxDate]="maxDate" [minDate]="minDate"
                                        (click)="creation_date_range.toggle(); showErrorBorder = false"
                                        [ngStyle]="{ 'border': showErrorBorder ? '1px solid red' : 'none' }"
                                        #creation_date_range="ngbDatepicker">
                                    <ng-template #creation let-date_creation="date" let-focused="focused">
                                        <span class="custom-day"
                                            [class.range]="isFromCreationDate(date_creation) || isToCreationDate(date_creation) || isInsideCreationDate(date_creation) || isHoveredCreationDate(date_creation)"
                                            [class.faded]="isHoveredCreationDate(date_creation) || isInsideCreationDate(date_creation)"
                                            (click)="onDateSelection(date_creation);"
                                            (mouseenter)="hoveredDateCreationDate = date_creation"
                                            (mouseleave)="hoveredDateCreationDate = null">
                                            {{ date_creation.day }}
                                        </span>
                                    </ng-template>
                            </div>
                            <div class="col-md-8" *ngIf="!module">
                                <ngb-timepicker
                                        formControlName="deadlineTime"
                                ></ngb-timepicker>
                            </div>

                            <div class="col-md-1 margin-left-100"
                                *ngIf="module === 'holidays' && deadlineObj && ((deadlineObj.from?.year + '-' + deadlineObj.from?.month + '-' + deadlineObj.from?.day) === (deadlineObj.to?.year + '-' + deadlineObj.to?.month + '-' + deadlineObj.to?.day) || !deadlineObj.to)">
                                <div class="align-items">
                                    <p class="hours-item">Sati:</p>
                                    <ngb-timepicker formControlName="absenceTime"></ngb-timepicker>
                                </div>
                            </div>

                            <div class="col-md-12 mt-3" *ngIf="module === 'holidays'">
                                <div class="row align-items-center">
                                    <div class="col-7">
                                        <h3 style="margin-top: 16px;color: gray;font-size: 13px;">
                                            Izaberite godinu iz koje su zahtjevani dani godišnjeg odmora:
                                        </h3>
                                    </div>
                                    <div class="col-5 margin-left-minus-70">
                                        <select [(ngModel)]="selectedYear" (change)="onYearChange($event); borderError = false" class="form-select width-85" [ngClass]="{'red-border': borderError}">
                                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 no-padding" *ngIf="eventType === 'meeting' && !module">
                            <div class="col-md-2 text-right no-padding">
                                <h3 style="color: gray;font-size: 13px;">Datum sastanka:</h3>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control no-border form-control-sm form-control-group"
                                       placeholder="Datum sastanka"
                                       formControlName="meetingDate"
                                       (click)="ms.toggle()"
                                       ngbDatepicker
                                       #ms="ngbDatepicker">
                                <div style="width: 120px;margin-top: 0.25rem;margin-left:9px;font-size: 80%;color: #dc3545"
                                     *ngIf="(form.get('meetingDate').invalid && form.get('meetingDate').touched)">Ovo polje je obavezno.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 no-padding" *ngIf="eventType === 'meeting' && !module">
                            <div class="col-md-2 text-right no-padding">
                                <h3 style="color: gray;font-size: 13px;margin-top: 25px;">Vrijeme sastanka:</h3>
                            </div>
                            <div class="col-md-3">
                                <ngb-timepicker formControlName="meetingStartTime"
                                >
                                </ngb-timepicker>
                                <div style="width: 120px;margin-top: 0.25rem;margin-left:9px;font-size: 80%;color: #dc3545"
                                     *ngIf="(form.get('meetingStartTime').invalid && form.get('meetingStartTime').touched)">Ovo polje je
                                    obavezno.
                                </div>
                            </div>
                            <div class="col-md-3">
                                <ngb-timepicker formControlName="meetingEndTime"

                                >
                                </ngb-timepicker>
                                <div style="width: 120px;margin-top: 0.25rem;margin-left:9px;font-size: 80%;color: #dc3545"
                                     *ngIf="form.get('meetingEndTime').invalid && form.get('meetingEndTime').touched">Ovo polje je obavezno.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 no-padding" *ngIf="eventType === 'reminder' && !module">
                            <div class="col-md-2 text-right no-padding">
                                <h3 style="color: gray;font-size: 13px;margin-top:25px;">Datum podsjetnika</h3>
                            </div>
                            <div class="col-md-2">
                                <input class="form-control no-border form-control-sm form-control-group"
                                       placeholder="Datum podsjetnika"
                                       style="margin-top:25px"
                                       formControlName="reminderDate"
                                       (click)="re.toggle()"
                                       ngbDatepicker #re="ngbDatepicker">
                                <div style="width: 120px;margin-top: 0.25rem;margin-left:9px;font-size: 80%;color: #dc3545"
                                     *ngIf="(form.get('reminderDate').invalid || form.get('reminderStartTime').invalid)">
                                    Ovo polje je obavezno.
                                </div>
                            </div>

                            <div class="col-md-8">
                                <ngb-timepicker
                                        formControlName="reminderStartTime"
                                ></ngb-timepicker>
                            </div>
                        </div>
                        <div class="col-md-2 text-right">
                            <h3 style="color: gray;font-size: 13px;margin-top: 16px">Opis:</h3>
                        </div>
                        <div class="form-group col-md-10 mt-2">
                            <angular-editor [config]="config"
                                            #editor
                                            (focusout)="getTaskDescription(editor.textArea.nativeElement.innerText)"
                            ></angular-editor>
                        </div>


                        <div *ngIf="eventType==='task' && !module" class="col-md-2 text-right">
                            <h3 style="color: gray;font-size: 13px;margin-top: 4px">Ostalo:</h3>
                        </div>
                        <div *ngIf="eventType==='task' && !module" class="form-group col-md-10 no-margin">
                            <label></label>
                            <div class="col-md-4 no-padding-left">
                                <app-select-project
                                        [myForm]="form"
                                        [projects]="projects"
                                        [isDisabled]="projectDisabled"
                                        [data]="project"
                                        (outputToParent)="getTaskProject($event)"
                                ></app-select-project>

                            </div>
                            <div class="col-md-4" *ngIf="!module">

                                <app-task-type
                                        [types]="types"
                                        [data]="taskType"
                                        (output)="getTaskType($event)"
                                        style="width: 60%"></app-task-type>

                            </div>
                            <div class="col-md-4 no-padding" *ngIf="!module">

                                <div class="btn-group">
                                    <button (click)="openEstimaionTimeDialog()"
                                            class="no-border no-padding-left"
                                            style="width: 100%"
                                            title="Procjena potrebnog vremena za izvršenje"
                                            mat-stroked-button>
                                        <mat-icon style="float: left;font-size: 24px;margin-top: 3px" class="work">alarm
                                        </mat-icon>
                                        {{estimationButtonTitle}}
                                    </button>
                                    <button [ngStyle]="{'visibility': estimation !=='' ?'inherit':'hidden'}"
                                            (click)="resetEstimate()" class="btn  shadow-none"
                                            type="button">
                                        <mat-icon style="margin-top: 5px;font-size:15px" class="work">close</mat-icon>
                                    </button>

                                </div>


                            </div>


                        </div>


                        <div class="clearfix mb-2"></div>
                        <div class="col-md-12 no-padding" *ngIf="eventType === 'task' && !module">
                            <div class="col-md-2 p-0 no-padding text-right">
                                <h3 style="color: gray;font-size: 13px;margin-top: 27px">Početak izvršavanja:</h3>
                            </div>
                            <div class="col-md-2">
                                <input class="form-control no-border form-control-sm form-control-group"
                                       placeholder="Izaberite datum"
                                       name="dp"
                                       style="margin-top: 25px"
                                       (click)="d.toggle()"
                                       [formControl]="executionDate"
                                       ngbDatepicker #d="ngbDatepicker">
                            </div>
                            <div class="col-md-8" [ngStyle]="{'pointer-events': mode==='copy'?'none':'auto' }" *ngIf="!module">
                                <ngb-timepicker [formControl]="executionStartTime"
                                ></ngb-timepicker>
                            </div>
                        </div>


                        <div style="max-height: 35px;" class="col-md-2 text-right" *ngIf="!module">
                            <h3 class="mb-0" style="margin-top: 10px;color: gray;font-size: 13px;">
                                Tagovi</h3>
                        </div>
                        <div class="form-group mb-0 col-md-10 no-padding-left" style="margin-top: -1px" *ngIf="!module">
                            <app-choose-tags [data]="tags"
                                             (outputToParent)="getTaskTags($event)"
                            ></app-choose-tags>
                        </div>
                        <div class="col-md-2 text-right" *ngIf="!module">
                            <h3 style="color: gray;font-size: 13px;margin-top: 16px">Prioritet:</h3>
                        </div>
                        <div class="form-group col-md-10 mt-2" *ngIf="!module">
                            <select (change)="setPriority($event.target)" #p
                                    style="width: 30% !important;font-size: 0.9rem;"
                                    class="selectpicker pl-0 form-select no-border form-control show-menu-arrow">
                                <option *ngFor="let item of priorities"
                                        [selected]="priority===item.id" [value]="item.id"
                                >{{item.name}}
                                </option>
                            </select>


                        </div>

                        <div class="col-md-2  text-right" *ngIf="!module">
                            <h3 style="color: gray;font-size: 13px;margin-top: 4px"></h3>
                        </div>
                        <div class="form-group no-margin no-padding-left col-md-10" *ngIf="!module">
                            <app-file-upload [data]="attachments"
                                             (outputToParent)="getAttachmentLinks($event)"></app-file-upload>

                        </div>
                    </div>

                </form>

            </section>


        </div>
    </main>
</ng-scrollbar>

<div class="footer">
    <footer class="modal-footer pb-0" id="modal-footer">
        <button style="margin-right: 15px" class="btn btn-light" (click)="closeModal()">Otkaži</button>
        <button class="btn btn-primary ml-3" [disabled]="buttonDisabled" (click)="saveTask()" *ngIf="!module">Sačuvaj</button>
        <button class="btn btn-primary ml-3" [disabled]="buttonDisabledHoliday" (click)="saveHolidayRequest()" *ngIf="module === 'holidays'">
            <span *ngIf="!buttonDisabledHoliday">Sačuvaj</span>
            <span *ngIf="buttonDisabledHoliday"><div class="loader"></div></span>
        </button>
    </footer>
</div>




